const specificDDDs = ["83", "84", "85", "88"];

export default specificDDDs;
